import React from 'react';
import Box from '@sizeid/commons/components/Box';
import Tabs from '@sizeid/commons/components/Tabs';
import Tab, { TabLabel, TabContent } from '@sizeid/commons/components/Tabs/Tab';
import { Icon } from '@sizeid/commons/components/SvgImage';
import { useRouter } from 'next/router';

import P from 'components/typo/P';
import { H1 } from 'components/typo/Heading';
import SignInForm from 'containers/SignInForm';
import SignUpForm from 'containers/SignUpForm';
import { useTranslation } from 'lib/i18n';

import ForgottenPasswordLink from './ForgottenPasswordLink';
import {
  headerCss,
  signFormsBoxStyle,
  signUpTabStyle,
  tabIconStyle,
} from './styles';
import { SignFormsProps } from './types';

const SignForms: React.FC<SignFormsProps> = props => {
  const router = useRouter();
  const { t } = useTranslation('pages');
  return (
    <Box css={signFormsBoxStyle(props.advisor)}>
      <H1 css={headerCss}>{t('sign.header')}</H1>
      <P css="margin: 0 auto 40px auto;" centered>
        {t('sign.text')}
      </P>

      <Tabs
        initialActiveTabIndex={
          parseInt(`${router.query.signFormsTab?.toString()}`, 10) || 0
        }
      >
        <Tab>
          <TabLabel>
            <Box css={tabIconStyle} row align>
              <Icon image="sizeid-label-inclined" red />
              {t('sign.signIn.title')}
            </Box>
          </TabLabel>
          <TabContent>
            <SignInForm />
            <ForgottenPasswordLink
              advisor={props.advisor}
              label={t('sign.forgottenPassword')}
            />
          </TabContent>
        </Tab>
        <Tab>
          <TabLabel>
            <Box css={tabIconStyle} row align>
              <Box css={signUpTabStyle}>
                <Icon image="sizeid-label-inclined" />
                <Icon image="add" primary />
              </Box>
              {t('sign.signUp.title')}
            </Box>
          </TabLabel>
          <TabContent>
            <SignUpForm />
          </TabContent>
        </Tab>
      </Tabs>
    </Box>
  );
};

export default SignForms;
